import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { rutValidator } from 'src/app/Services/Utils/Validators/rut.validator';
import { Observable } from 'rxjs';
import { UserData } from 'src/app/Models/Account/getErpUser-result';
import { startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormatoRutPipe } from 'src/app/Services/Utils/Pipes/format-rut.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../modal/modal.component';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-modal-create-user',
  templateUrl: './modal-create-user.component.html',
  styleUrls: ['./modal-create-user.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
    , MatInputModule
    , MatFormFieldModule
    , MatAutocompleteModule
    , MatIconModule
    , CommonModule
    , ModalComponent
  ]
})
export class ModalCreateUserComponent{
  pass = false;
  form: FormGroup = new FormGroup({
    erpUserId: new FormControl('', [Validators.required]),
    rut: new FormControl('', [Validators.required, rutValidator]),
    firstName: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    firstEmail: new FormControl('', [Validators.required, Validators.email]),
    secondEmail: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
  });

  userList$: Observable<UserData[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string
    , public appStateService: AppStateService
    , private legalCodeAux: FormatoRutPipe
  ) {
    this.userList$ = this.form.get('erpUserId')!.valueChanges.pipe(
      startWith('')
      , debounceTime(600)
      , distinctUntilChanged()
      , switchMap(c => this.appStateService.UserService.GetErpUsers(c || ''))
    )
  }


  onSubmit() {
    const { value } = this.form
    this.appStateService.UserService.CreateAccount(value);
  }
  
  get ErpUser(): string{
    return this.form.get('erpUserId')?.value || ''
  }

  get FirstName(){
    return this.form.get('firstName')
  }

  get Password():string{
    return this.form.get('password')?.value
  }

  hasError(index: number): boolean{
    if(!this.Password.length) return true;
    const value  = this.Password;
    const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
    switch (index) {
      case 1:
        return String(value).length < 10 || String(value).length > 50

      case 2:
        return !String(value).match(patterns[patterns.length - 1]) || false

      case 3:
        return !String(value).match(patterns[patterns.length - 2]) || false

      case 4:
        return !String(value).match(patterns[patterns.length - 3]) || false

      case 5:
        return !String(value).match(patterns[patterns.length - 4]) || false

      default:
        return false
    }
  }

  get LegalCode(){
    return this.form.get('rut')
  }

  selectUsers({name, erpUserID}: any) {
    this.FirstName?.patchValue(name)
  }

  onChange({value}: any){
    this.LegalCode?.patchValue(this.legalCodeAux.transform(value))
  }

  get onValidation(): boolean{
    const 
    { invalid } = this.form,
    hasError = [1,2,3,4,5].map(c => this.hasError(c)).filter(Boolean),
    end = !invalid && !hasError.length;
    return !end;
  }
}
